var React = require('react');

function Editv2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.93 24.895L26.455 9.368 22.92 5.833 7.492 21.26c1.589.684 2.84 2.001 3.437 3.634zm-2.176 1.509a3.815 3.815 0 0 0-2.85-3.046l-.378 3.404 3.228-.358zM21.86 2.65a1.5 1.5 0 0 1 2.121 0l5.657 5.657a1.5 1.5 0 0 1 0 2.12L11.253 28.815a1.5 1.5 0 0 1-.895.43l-6.364.707a1.5 1.5 0 0 1-1.656-1.656l.707-6.364a1.5 1.5 0 0 1 .43-.895L21.86 2.65z"}));
}

Editv2.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Editv2;

Editv2.default = Editv2;
